import { InfiniteData, useInfiniteQuery, UseInfiniteQueryResult } from '@tanstack/react-query';

import { SurveyTemplate, SurveyTemplateTypes } from 'types/survey_template.types';

import { getSurveyTemplates } from '../api/feedback/getSurveyTemplates';

interface UseTemplatesQueryParams {
  searchText: string;
  enabled: boolean;
  type: SurveyTemplateTypes;
}

const ITEM_PER_PAGE = 20;

export const useTemplatesQuery = ({
  searchText,
  enabled,
  type
}: UseTemplatesQueryParams): UseInfiniteQueryResult<
  InfiniteData<{
    templates: SurveyTemplate[];
    pageTotal: number;
    nextPage: number;
  }>
> => {
  return useInfiniteQuery({
    queryKey: ['surveyTemplates', searchText, type],
    queryFn: async ({ pageParam = 0 }) => {
      const result = await getSurveyTemplates({
        searchText,
        selectedTypeFilters: [type],
        perPage: ITEM_PER_PAGE,
        tabType: 'published',
        currPage: pageParam
      });

      return {
        templates: result.editableSurveyTemplates.surveyTemplates,
        pageTotal: result.editableSurveyTemplates.pageTotal,
        nextPage: pageParam + 1
      };
    },
    getNextPageParam: (lastPage, pages) => {
      if (pages.length < lastPage.pageTotal) {
        return lastPage.nextPage;
      }
      return undefined;
    },
    enabled,
    initialPageParam: 0
  });
};
